import { fetchApi } from '@/config/axiosSetting.ts';
import { ReferToBranchActionMutationDataType } from '@/modules/FileDetail/queries/sendActions/referToBranchAction/referToBranchActionMutationFn.types';

export const referToBranchActionMutationFn = (
  data: ReferToBranchActionMutationDataType,
  id: string,
) => fetchApi.post(`actions/${id}/refer_to_branch/`, data);
